import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Display from "../components/display/display"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
   <Display />
  </Layout>
)

export default IndexPage
